import React, { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { exportStripeDataAsync, fetchAllAdminStripeAsync, selectAdminStripes, selectExportStatus } from './AdminStripeSlice'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { format, subMonths } from 'date-fns'
import { Delete, Download, SwapHoriz, Refresh } from '@mui/icons-material'
import { selectAuthUser } from '../auth/AuthSlice'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

const AdminStripe = () => {
  const dispatch = useAppDispatch()
  const adminStripes = useAppSelector(selectAdminStripes)
  const exportStatus = useAppSelector(selectExportStatus)
  const navigate = useNavigate()
  const authUser = useAppSelector(selectAuthUser)
  const [exportMonth, setExportMonth] = useState<Date | null>(subMonths(new Date(), 1))

  useEffect(() => {
    dispatch(fetchAllAdminStripeAsync({ mode: 'regular', userAuthorities: authUser?.authorities }))
  }, [])

  const handleExport = () => {
    const month = exportMonth ? format(exportMonth, 'yyyy-MM') : undefined
    dispatch(exportStripeDataAsync({ month })).unwrap().then((result) => {
      if (result?.downloadUrl) {
        window.open(result.downloadUrl, '_blank')
      }
    })
  }

  return (<div>
    <h1>Stripe Subscriptions</h1>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 2 }}>
      <Button onClick={() => dispatch(fetchAllAdminStripeAsync({ mode: 'regular', userAuthorities: authUser?.authorities }))}><Refresh /> Reload</Button>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Export Month"
          views={['year', 'month']}
          value={exportMonth}
          onChange={(newValue) => setExportMonth(newValue)}
          slotProps={{ textField: { size: 'small' } }}
        />
      </LocalizationProvider>
      <Button
        variant="contained"
        onClick={handleExport}
        disabled={exportStatus === 'loading'}
        startIcon={exportStatus === 'loading' ? <CircularProgress size={20} /> : <Download />}
      >
        Export
      </Button>
    </Box>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Stripe ID</TableCell>
            <TableCell>User Email</TableCell>
            <TableCell>Stripe Email</TableCell>
            <TableCell>Subscription</TableCell>
            <TableCell>time</TableCell>
            <TableCell> </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {adminStripes.content?.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row.stripeId?.slice(-20)}</TableCell>
              <TableCell>{row.userEmail}</TableCell>
              <TableCell>{row.stripeEmail}</TableCell>
              <TableCell>{row.subscriptionDurationMode}</TableCell>
              <TableCell>{format(new Date(row.eventTime * 1000), 'yyyy-MM-dd HH:mm:ss')}</TableCell>
              <TableCell>
                <Button onClick={() => navigate(`/admin/stripe/transfer/${row.id}`)}><SwapHoriz /></Button>
                <Button onClick={() => navigate(`/admin/orgs/delete/${row.id}`)}><Delete /></Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>)
}

export default AdminStripe